import { AccountType } from '@coworkrz/accounts/types';
import { Type } from 'class-transformer';
import {
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsPositive,
  ValidateNested,
} from 'class-validator';

class AccountDto {
  @IsNotEmpty()
  id!: number;

  @IsNotEmpty()
  type!: AccountType;

  @IsNotEmpty()
  synchronize!: boolean;

  @IsOptional()
  externalRef!: number;
}

export class CreatePaymentDto {
  @IsNotEmpty()
  @IsPositive()
  amount!: number;

  @IsNotEmpty()
  @IsDateString()
  valueDate: Date;

  @IsNotEmpty()
  invoiceId!: string;

  @IsNotEmpty()
  @Type(() => AccountDto)
  @ValidateNested({ each: true })
  account!: AccountDto;
}
